import React, { createContext, useState, useEffect } from "react";
import { ApiURLs } from "../constant/ApiUrls";
import { fetchData } from "../services/api";

export const AdminContext = createContext();

export const AdminProvider = ({ children }) => {
    const [adminData, setAdminData] = useState(null);
    const [unreadSuspiciousActivity, setUnreadSuspiciousActivity] = useState(0);

    const loadAdminDetails = async () => {
        try {
            const url = `${ApiURLs.ADMIN_DETAIL}`;
            const response = await fetchData(url);

            console.log("REsPONCE DATTATAAT:::::", response.data);
            if (response.status === 1) {
                setAdminData(response.data.admin_info);
                setUnreadSuspiciousActivity(
                    response.data.admin_info.unread_suspicious_activity
                );
            }
        } catch (error) {
            console.log("Error fetching admin details", error);
        }
    };

    // 🔥 This runs every time website loads
    useEffect(() => {
        loadAdminDetails();
    }, []);

    return (
        <AdminContext.Provider
            value={{
                adminData,
                unreadSuspiciousActivity,
                setUnreadSuspiciousActivity,
                reloadAdmin: loadAdminDetails
            }}
        >
            {children}
        </AdminContext.Provider>
    );
};